import { TableColumn } from '@backstage/core-components';
import { Chip } from '@material-ui/core';
import { CatalogTableRow } from '@backstage/plugin-catalog';

/**
 * Custom catalog table column that shows Crossplane Ready status
 * for Resource entities. Shows a colored chip: green for True, red for False, grey for Unknown.
 */
export const crossplaneReadyColumn: TableColumn<CatalogTableRow> = {
  title: 'Ready',
  customSort: ({ entity: a }, { entity: b }) => {
    const readyA =
      a.metadata.annotations?.['ciandtspike.io/crossplane-ready'] ?? '';
    const readyB =
      b.metadata.annotations?.['ciandtspike.io/crossplane-ready'] ?? '';
    return readyA.localeCompare(readyB);
  },
  render: ({ entity }) => {
    if (entity.kind !== 'Resource') return null;

    const ready =
      entity.metadata.annotations?.['ciandtspike.io/crossplane-ready'];
    const reason =
      entity.metadata.annotations?.['ciandtspike.io/crossplane-ready-reason'] ||
      '';

    const isReady = ready === 'True';
    return (
      <Chip
        label={reason || (isReady ? 'Ready' : 'Not Ready')}
        size="small"
        style={{
          backgroundColor: isReady ? '#22c55e' : '#ef4444',
          color: 'white',
          fontWeight: 500,
        }}
      />
    );
  },
};
